import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BackendListModel } from "src/app/models/common/list.model";
import { ApiRoutes } from "src/app/services/apiroutes";
import { ILeadVerificationModel } from "./lead-verification/lead-verification.model";
import { KycStatusModel } from "src/app/models/customer_master_model/company-model";
import { UserTaxIdentifiersModel } from "src/app/models/customer_master_model/tax-identifiers";
import { Observable } from "rxjs";
import { LocationModel } from "src/app/models/container_master_model/location";

@Injectable({
    providedIn: 'root'
})

export class VerifyCustomerService {
    approvalStatus = { "value": "", "label": "All" };
    nature= { "value": "", "label": "" };

    constructor(private http: HttpClient) { }

    getUsers(searchTerm = null, approval_status = '',nature='', page_size = 10, page = 1, order = '') {
        let url = new URL(`${ApiRoutes.Company}external_invite_for_verification/`);
        if (searchTerm) {
            url.searchParams.append('search', searchTerm);
        }
        url.searchParams.append('page_size', String(page_size));
        url.searchParams.append('page', String(page));
        if (order != null && order != '') {
            url.searchParams.append('o', String(order));
        }
        if (approval_status != null && approval_status != '') {
            url.searchParams.append('lead_status', String(approval_status));
        }
        if (nature != null && nature != '') {
            url.searchParams.append('nature', String(nature));
        }
        return this.http.get<BackendListModel<any>>(url.toString());
    }

    getLeadById(lead_id) {
        let url = `${ApiRoutes.LeadRequest}leads/${lead_id}/`;
        return this.http.get<ILeadVerificationModel>(url);
    }

    getUserById(user_id) {
        let url = `${ApiRoutes.Company}external_invite_for_verification/${user_id}/`;
        return this.http.get<any>(url);
    }

    putLead(data, lead_id) {
        let url = `${ApiRoutes.LeadRequest}leads/${lead_id}/verify/`;
        return this.http.put(url, data);
    }

    putUser(data, user_id) {
        let url = `${ApiRoutes.LeadRequest}leads/user_verification/${user_id}/`;
        return this.http.put(url, data);
    }

    getNatureOfRequest(request: any) {
        switch (request.request_type.dev_name) {
            case 'lease':
                if (request.transaction_type == 'use')
                    return 'Lease | Use';
                else
                    return 'Lease | Supply';
            case 'one_way':
                if (request.transaction_type == 'use')
                    return 'One Way | Use';
                else
                    return 'One Way | Supply';
            case 'buy_sell':
                if (request.transaction_type == 'use')
                    return 'Trade | Buy';
                else
                    return 'Trade | Sell';
            case 'empty_repo':
                if (request.transaction_type == 'use')
                    return 'Empty Repo | Use';
                else
                    return '';
        }
        return '-';
    }

    getCompanies(searchTerm = null, status = null, page_size = 10, page = 1, order = '') {
        let url = new URL(`${ApiRoutes.Company}company/`);
        if (searchTerm) {
            url.searchParams.append('search', searchTerm);
        }
        url.searchParams.append('page_size', String(page_size));
        url.searchParams.append('page', String(page));
        if (order != null && order != '') {
            url.searchParams.append('o', String(order));
        }
        if (status != null && status != '') {
            url.searchParams.append('kyc_status', String(status));
        }

        return this.http.get<BackendListModel<any>>(url.toString());
    }

    getKycStatusList() {
        let url = `${ApiRoutes.Company}kyc_master/`;
        return this.http.get<BackendListModel<KycStatusModel>>(url);
    }

    getKycDocsOfCompany(companyId) {
        let url = `${ApiRoutes.Company}user_tax_identifier/?company=${companyId}`;
        return this.http.get<BackendListModel<UserTaxIdentifiersModel>>(url);
    }

    putKycDocsOfCompany(id, data) {
        let url = `${ApiRoutes.Company}kyc_status_change/${id}/`;
        return this.http.put(url, data);
    }
    getResourceSourceOptions() {
        let url = `${ApiRoutes.LeadRequest}leads/`;
        return this.http.options(url);
    }

    postLeadData(data) {
        let url = `${ApiRoutes.LeadRequest}leads/`;
        return this.http.post(url, data);
    }

    postUser(data) {
        let url = `${ApiRoutes.Company}external_invite/`;
        return this.http.post(url, data);
    }

    optionsLeadExternalInvite() {
        let url = `${ApiRoutes.Company}external_invite/`;
        return this.http.options(url);
    }
    // getPortLocation(): Observable<BackendListModel<LocationModel>> {
    //     let url = `${this.base_url}?location_type_name=port`;
    //     return this.http.get<BackendListModel<LocationModel>>(url);
    // }
    getPols(page_size = 300, page = 1): Observable<BackendListModel<LocationModel>> {
        let url = `${ApiRoutes.Location}?location_type_name=port`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        return this.http.get<BackendListModel<LocationModel>>(String(urlObj));
    }
    getPods(page_size = 300, page = 1): Observable<BackendListModel<LocationModel>> {
        let url = `${ApiRoutes.Location}?location_type_name=port`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        return this.http.get<BackendListModel<LocationModel>>(String(urlObj));
    }
}
